module.exports = __webpack_public_path__ + "static/media/card-swipe.714fc6d6.jpg";